import axios from 'axios'
import { API_BASE } from '../config'

function authHeaders() {
    return { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
}

export default class Games {
    // GET /game/link/:code - A game's sign-in link: { success, game, approved }. Rejects if the code has expired.
    getLink(code) {
        return axios.get(`${API_BASE}/game/link/${encodeURIComponent(code)}`).then(x => x.data);
    }

    // POST /game/link/approve - Sign the waiting game in as the logged-in user: { success, username }
    approveLink(code) {
        return axios.post(`${API_BASE}/game/link/approve`, { code }, authHeaders()).then(x => x.data);
    }

    // GET /spacejump/leaderboard - Every Space Jump board's top players:
    // { run, levels: [{ id, name }], boards: { <board>: { fastest: [entry], jumps: [entry] } } }
    getSpaceJumpLeaderboard() {
        return axios.get(`${API_BASE}/spacejump/leaderboard`).then(x => x.data);
    }

    // GET /clicker/me - The logged-in player's Clompy Clicker game:
    // { coins, allTime, clicks, seconds, awaySeconds, levels, owned, equipped, perClick, perSecond } - diamonds they
    // have now (the backend calls them coins), diamonds ever earned, clicks ever made, seconds played and seconds
    // their Cold Brew Tower has spent earning while they were away; then their level in each
    // shop upgrade, the cosmetics they own, the one worn in each slot, and what a click and a second earn them
    getClickerCoins() {
        return axios.get(`${API_BASE}/clicker/me`, authHeaders()).then(x => x.data);
    }

    // POST /clicker/clicks - Add the clicks made and seconds played since the last report: the player's game as
    // above, with counted (how many of the clicks were accepted). active is how many of the seconds the player was
    // really playing, which is what earns Clomp Coins.
    addClickerClicks(clicks, seconds, active) {
        return axios.post(`${API_BASE}/clicker/clicks`, { clicks, seconds, active }, authHeaders()).then(x => x.data);
    }

    // GET /clicker/shop - What the shop sells: { upgrades: [{ id, name, description, maxLevel, costs }],
    // slots: [{ id, name }], cosmetics: [{ id, slot, name, cost }], achievements: [{ id, title, description }] } where
    // costs[level] is the price of the next level, and achievements is every achievement the game has. (A player's
    // game, from the calls below, lists the ids they have earned as `achievements`, and those just earned as `unlocked`.)
    getClickerShop() {
        return axios.get(`${API_BASE}/clicker/shop`).then(x => x.data);
    }

    // POST /clicker/buy - Buy an upgrade's next level, or a cosmetic (which is put on): the player's game afterwards
    buyClickerItem(item) {
        return axios.post(`${API_BASE}/clicker/buy`, { item }, authHeaders()).then(x => x.data);
    }

    // POST /clicker/equip - Put on a cosmetic the player owns: the player's game afterwards
    equipClickerItem(item) {
        return axios.post(`${API_BASE}/clicker/equip`, { item }, authHeaders()).then(x => x.data);
    }

    // POST /clicker/away - The game was opened or come back to: the player's game after being paid what their
    // Cold Brew Tower earned meanwhile, with away ({ seconds, counted, earned }, or null if they weren't gone long enough)
    collectClickerAway() {
        return axios.post(`${API_BASE}/clicker/away`, {}, authHeaders()).then(x => x.data);
    }

    // POST /clicker/golden - A golden diamond was caught: the player's game afterwards, with reward (what it paid)
    claimClickerGolden() {
        return axios.post(`${API_BASE}/clicker/golden`, {}, authHeaders()).then(x => x.data);
    }

    // GET /clicker/leaderboard - The players who have earned the most diamonds of all time: { entries: [{ id, player, value, date }] }
    getClickerLeaderboard() {
        return axios.get(`${API_BASE}/clicker/leaderboard`).then(x => x.data);
    }

}
